// @flow

import React from 'react';
import I18n from 'PMT/i18n/I18n';

export default function ServerErrorPage() {
  return (
    <div id="server_error_page">
      <h1 className="text-center">
        {I18n.tr('server_error.title')}
      </h1>

      <div className="top-buffer-50 text-center">
        <h2 className="text-center">
          {I18n.tr('server_error.message')}
        </h2>

        <p style={{fontStyle: 'italic'}} className="top-buffer-50">
          {`Session-id: ` +
              new URLSearchParams(window.location.search).get('sessionId')}
        </p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./scripts/pages/other/ServerErrorPage.js